import { h } from "preact";
import { useCollection } from "./CollectionContext";
import { SelectedFilter } from "../types";

// FiltersForm component to handle filtering functionality
function FiltersForm(query: { query: string }) {
  const { filters, selectedFilters, setSelectedFilters } = useCollection();

  // Function to handle opening and closing of filter options
  const handleOpenFilterOptions = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    const filterTitle = target.closest(".filters__title") as HTMLElement;

    if (!filterTitle) {
      return;
    }

    const filterGroup = filterTitle.closest(".filters__group");

    if (filterGroup) {
      filterGroup.classList.toggle("filters__group--open");
    }

    // Close all other open filter groups
    const allFilters = document.querySelectorAll(".filters__group");
    allFilters.forEach((filter) => {
      if (filter !== filterGroup) {
        filter.classList.remove("filters__group--open");
      }
    });

    // Close filter options when clicked outside
    document.addEventListener("click", (e) => {
      const target = e.target as HTMLElement;
      if (!target.closest(".filters")) {
        allFilters.forEach((filter) => {
          filter.classList.remove("filters__group--open");
        });
      }
    });
  };

  // Function to handle changes in filter selection
  const handleFilterChange = (
    param_name: string,
    type: string,
    label: string,
    event: Event,
  ) => {
    const target = event.target as HTMLInputElement;
    if (!target) return;

    const isChecked = target.checked;
    const getNewSelectedFilters = (
      currentFilters: SelectedFilter[],
    ): SelectedFilter[] => {
      const newFilters = [...currentFilters];
      const existingFilterIndex = newFilters.findIndex(
        (filter) => filter.param_name === param_name,
      );

      // Update existing filter or add new filter based on the checkbox state
      if (existingFilterIndex !== -1) {
        const newValues = isChecked
          ? [...newFilters[existingFilterIndex].values, label]
          : newFilters[existingFilterIndex].values.filter((v) => v !== label);

        if (newValues.length > 0) {
          newFilters[existingFilterIndex] = {
            ...newFilters[existingFilterIndex],
            values: newValues,
          };
        } else {
          newFilters.splice(existingFilterIndex, 1);
        }
      } else if (isChecked) {
        newFilters.push({ param_name, values: [label], type });
      }

      return newFilters;
    };

    setSelectedFilters(getNewSelectedFilters(selectedFilters));
    // setPagination({ ...pagination, currentPage: 1 });
  };

  const template = window.themeVars.store.template;
  let showFilterLoadingState = false;

  if (!filters.length) {
    showFilterLoadingState = true;

    if (template === "search" && !query.query) {
      showFilterLoadingState = false;
    }
  }

  if (showFilterLoadingState) {
    return (
      <div
        className="
        filters
        is-loading__skeleton
      "
      ></div>
    );
  }

  return (
    <div className="filters" onClick={handleOpenFilterOptions}>
      {filters.map((filter) => (
        <div className="filters__group" key={filter.param_name}>
          <p className="filters__title text-md-body--semi-bold">
            {filter.label}
            <span
              className="filters__chevron"
              dangerouslySetInnerHTML={{
                __html: window.themeVars.icons.chevronDown,
              }}
            ></span>
          </p>
          <div className="filters__options">
            {filter.values.map((option) => (
              <label key={option.label}>
                <input
                  type="checkbox"
                  value={option.label}
                  checked={selectedFilters.some(
                    (f) =>
                      f.param_name === filter.param_name &&
                      f.values.includes(option.label),
                  )}
                  onChange={(event) =>
                    handleFilterChange(
                      filter.param_name,
                      filter.type,
                      option.label,
                      event,
                    )
                  }
                />
                {option.label}
              </label>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default FiltersForm;
